// extracted by mini-css-extract-plugin
module.exports = {"theme":"#000","black":"#333","red":"#ea625b","green":"#38ca73","bgGradient":"linear-gradient(90deg, #0af, #0085ff)"};